import type { PropsWithChildren } from "react";

import { StateDevTools } from "./state-dev-tools";

export const StateProvider = ({ children }: PropsWithChildren) => {
  return <StateDevTools>{children}</StateDevTools>;
};
